import Vue from 'vue';
import VueRouter from 'vue-router';
import { routes, communeRoutes } from '@/routes/routes';

Vue.use(VueRouter);

export const router = new VueRouter({ routes: [...routes, ...communeRoutes], mode: 'history' });
